import { checkIfOldApp, getAppVersion } from '/src/App/OfflineApp/offlineAppHelper';
import UpdateAppButton from '/src/views/OfflineApps/UpdateAppButton';
import { useTranslate } from "/src/lib/MrTranslate/MrTranslate";
import { Button, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { appTypeSelector } from "/src/App/OfflineApp/offlineAppSelectors";
import { useSelector } from 'react-redux';

const OldAppModal = () => {
  const translate = useTranslate();
  const appType = useSelector(appTypeSelector());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const appVersion = getAppVersion(appType);
  useEffect(() => {
    const isOldApp = checkIfOldApp(appType);
    if (isOldApp) {
      setIsModalOpen(true);
    }
  }, [appType]);

  return (
    <Modal
      open={isModalOpen}
      title={translate('OldAppModal.app_update_available')}
      onCancel={() => setIsModalOpen(false)}
      footer={
        <>
          <Button onClick={() => setIsModalOpen(false)} danger>
            {translate('OldAppModal.keep_using_this_version')}
          </Button>
          {/* NOTE: The "App update" button (UpdateAppButton) is temporarily removed because it does not function correctly when security mode is enabled.
          Future work: Re-enable UpdateAppButton once secure update flows are fully supported. */}
          {/* <UpdateAppButton /> */}
        </>
      }
      maskClosable={false}
      closable={false}
      centered
      zIndex={1060}
      keyboard={false}
      destroyOnHidden
    >
      <div className="old-app-modal-content">
        <p>{translate('OldAppModal.your_app_version_is_outdated', {appVersion: appVersion})}</p>
        <p>{translate('OldAppModal.whats_new')}</p>
        <ul>
          <li>{translate('OldAppModal.improved_performance')}</li>
          <li>{translate('OldAppModal.bug_fixes')}</li>
          <li>{translate('OldAppModal.new_features')}</li>
          <li>{translate('OldAppModal.enhanced_security')}</li>
        </ul>
      </div>
    </Modal>
  );
};

export default OldAppModal;